import React from "react";
import {
  Box,
  Typography,
  Button, 
  Card,
  CardContent,
  Stack,
  Grid,
  Divider,
} from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import AddNoteDialog from "../../prestamos/notas/index.js";
import { formatNumberWithCommas } from "../../../../utils/generalFunctions";

export default function Mora({ moraData = {} }) {
  const { mora_aging = {}, top_mora_accounts = [] } = moraData;
  
  // State for note dialog
  const [openNoteDialog, setOpenNoteDialog] = React.useState(false);
  const [selectedLoanId, setSelectedLoanId] = React.useState(null);
  const [selectedLoanInfo, setSelectedLoanInfo] = React.useState(null);
  
  // Calculate percentages for the aging buckets
  const totalAmount = mora_aging.total_delinquent_amount || 0;
  const currentAmount = mora_aging.current_amount || 0;
  const days1_30Amount = mora_aging.days_1_30_amount || 0;
  const days31_60Amount = mora_aging.days_31_60_amount || 0;
  const days61_90Amount = mora_aging.days_61_90_amount || 0;
  const days90PlusAmount = mora_aging.days_90_plus_amount || 0;
  
  const getWidthPercentage = (amount) => {
    if (totalAmount === 0) return 0;
    return Math.max((amount / totalAmount) * 100, 2); // Minimum 2% width for visibility
  };
  
  const formatDaysPastDue = (days) => {
    if (days === 1) return '1 día en mora';
    return `${days} días en mora`;
  };

  // Handle opening note dialog
  const handleOpenNoteDialog = (loan) => {
    setSelectedLoanId(loan.id);
    setSelectedLoanInfo(loan);
    setOpenNoteDialog(true);
  };


  
  return (
    <Box sx={{ flexGrow: 1, bgcolor: "#f8f9fa", minHeight: "100vh" }}>
      <Box sx={{ p: 3 }}>
        <Stack spacing={3}>
          <Card variant="outlined" sx={{ p: 3 }}>
            <Typography variant="h6">Envejecimiento de Mora</Typography>
            <Typography variant="body2" color="text.secondary">
              Distribución de cuentas en mora por períodos de envejecimiento.
            </Typography>
            <Box sx={{ mt: 3, display: "flex", height: 50, borderRadius: 1, overflow: "hidden" }}>
              <Box sx={{ bgcolor: "#a5d6a7", width: `${getWidthPercentage(currentAmount)}%`, textAlign: "center", p: 1 }}>
                {/* <Typography variant="caption">Al Día</Typography> */}
                <Typography variant="caption">{formatNumberWithCommas(currentAmount)}</Typography>
              </Box>
              <Box sx={{ bgcolor: "#fff59d", width: `${getWidthPercentage(days1_30Amount)}%`, textAlign: "center", p: 1 }}>
                {/* <Typography variant="caption">1-30</Typography> */}
                <Typography variant="caption">{formatNumberWithCommas(days1_30Amount)}</Typography>
              </Box>
              <Box sx={{ bgcolor: "#ffcc80", width: `${getWidthPercentage(days31_60Amount)}%`, textAlign: "center", p: 1 }}>
                {/* <Typography variant="caption">31-60</Typography> */}
                <Typography variant="caption">{formatNumberWithCommas(days31_60Amount)}</Typography>
              </Box>
              <Box sx={{ bgcolor: "#ef9a9a", width: `${getWidthPercentage(days61_90Amount)}%`, textAlign: "center", p: 1 }}>
                {/* <Typography variant="caption">61-90</Typography> */}
                <Typography variant="caption">{formatNumberWithCommas(days61_90Amount)}</Typography>
              </Box>
              <Box sx={{ bgcolor: "#e57373", width: `${getWidthPercentage(days90PlusAmount)}%`, textAlign: "center", p: 1 }}>
                {/* <Typography variant="caption">90+</Typography> */}
                <Typography variant="caption">{formatNumberWithCommas(days90PlusAmount)}</Typography>
              </Box>
            </Box>
            <Stack direction="row" justifyContent="space-between" mt={1}>
              <Typography variant="caption">Al Día</Typography>
              <Typography variant="caption">1-30 Días</Typography>
              <Typography variant="caption">31-60 Días</Typography>
              <Typography variant="caption">61-90 Días</Typography>
              <Typography variant="caption">90+ Días</Typography>
            </Stack>
          </Card>

          <Box>
            <Typography variant="h6" mb={2}>
              Cuentas Top en Mora
            </Typography>
            {top_mora_accounts.length > 0 ? (
              <Grid container spacing={2}>
                {top_mora_accounts.map((acc) => (
                  <Grid item size={3} key={acc.id}>
                    <Card variant="outlined">
                      <CardContent>
                        <Stack direction="row" justifyContent="space-between">
                          <Box textAlign="left">
                            <Typography fontWeight="bold" color="primary">{acc.loan_id}</Typography>
                            <Typography variant="body2">{acc.cliente_nombre}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Sucursal: {acc.sucursal_nombre}
                            </Typography>
                          </Box>
                          <Box textAlign="right">
                            <Typography color="error" fontWeight="bold">{formatNumberWithCommas(acc.total_pendiente)}</Typography>
                            <Typography color="error" variant="body2">{formatDaysPastDue(acc.dias_mora)}</Typography>
                          </Box>
                        </Stack>
                        <Divider sx={{ my: 1 }} />
                        <Stack direction="row" spacing={1}>
                          {/* <Button size="small" startIcon={<CallIcon />} variant="outlined">Llamar</Button> */}
                          <Button 
                            size="small" 
                            startIcon={<NoteAddIcon />} 
                            variant="outlined"
                            onClick={() => handleOpenNoteDialog(acc)}
                          >
                            Nota
                          </Button>
                          {/* <Button size="small" startIcon={<VolunteerActivismIcon />} variant="outlined">PTP</Button> */}
                          {/* <Button size="small" startIcon={<AssignmentIndIcon />} variant="outlined">Asignar</Button> */}
                          {/* <Button size="small" startIcon={<AssignmentIndIcon />} variant="outlined">Asignar</Button> */}
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="body2" color="text.secondary" textAlign="center">
                    No hay cuentas en mora en este portafolio.
                  </Typography>
                </CardContent>
              </Card>
            )}
          </Box>
        </Stack>
      </Box>
      <AddNoteDialog
        open={openNoteDialog}
        loanId={selectedLoanId}
        loanInfo={selectedLoanInfo}
        onClose={() => setOpenNoteDialog(false)}
      />
    </Box>
  );
}
